import { z } from 'zod'

import type { Language } from '@nxt-insurance/constants'

import { childSavingSchema } from '@flows/configs/de/childSaving/types'
import type { generateGetFlowValueFunctions } from '@flows/insurance/utils'

export interface ChildSavingStepParams {
  getCurrentLanguage: () => Language
  helperFunctions: ReturnType<typeof generateGetFlowValueFunctions>
  environment: string
  platform: 'web' | 'native'
}

export const numberOfChildrenSchema = z.object({
  products: z.object({
    mga_child_saving_de: z.object({
      configuration_parameters: childSavingSchema.pick({
        number_of_children: true,
      }),
    }),
  }),
})

export const amountOfMoneySchema = z.object({
  products: z.object({
    mga_child_saving_de: z.object({
      configuration_parameters: childSavingSchema.pick({
        amount_of_money: true,
      }),
    }),
  }),
})

export const sustainabilitySchema = z.object({
  products: z.object({
    mga_child_saving_de: z.object({
      configuration_parameters: childSavingSchema.pick({
        sustainability: true,
      }),
    }),
  }),
})

export const quoteSchema = z.object({})

export const successSchema = z.object({})
